import React, { Fragment, useEffect, useState, useRef, forwardRef } from 'react';
import Subscriptions from './Subscription';
import { translate } from '../../../../Services/translation';
import { post } from '../../../../Services/http';
import { SubscriptionIntiatedStatus } from '../../../../constants';
import { useSelector } from 'react-redux';

const SubscriptionContainer = (props) => {
  const subscription1 = useRef(null);
  const subscription2 = useRef(null);
  const [validationsubscription1, setvalidationsubscription1] = useState([]);
  const [validationsubscription2, setvalidationsubscription2] = useState([]);
  const [error, seterror] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const [samesubscriptionForLeftEye, setsamesubscriptionForLeftEye] = useState(false);
  const [anyProductSelected, setanyProductSelected] = useState(false);
  const [paymentMethod, setpaymentMethod] = useState('');
  const [paymentMethodError, setpaymentMethodError] = useState(false);
  const [leftEyePrice, setleftEyePrice] = useState(0);
  const [rightEyePrice, setrightEyePrice] = useState(0);
  const [leftIsSixMonthsDelivery, setleftIsSixMonthsDelivery] = useState(false);
  const [rightIsSixMonthsDelivery, setrightIsSixMonthsDelivery] = useState(false);
  const [totalPriceOnEdit, settotalPriceOnEdit] = useState(0);
  const [leftEyeNumberOfPackets, setleftEyeNumberOfPackets] = useState(0);
  const [rightEyeNumberOfPackets, setrightEyeNumberOfPackets] = useState(0);
  const [clinicalPartActive, setClinicalPartActive] = useState(props.subscriptionToEdit.clinicalPartActive);
  const [storeMarkedNoFreeMonth, setstoreMarkedNoFreeMonth] = useState(props.subscriptionToEdit.storeMarkedNoFreeMonth);

  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const tooltipRef = useRef(null);
  const tooltipDescriptionRef = useRef(null);
  const lensSpecifications = useSelector((state) => state.lensSpecifications?.payload);
  const [lensSpecificationChangedInEdit, setlensSpecificationChangedInEdit] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target) &&
        tooltipDescriptionRef.current &&
        !tooltipDescriptionRef.current.contains(event.target)
      ) {
        setIsTooltipVisible(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleTooltipClick = () => {
    setIsTooltipVisible(!isTooltipVisible);
  };

  const handleClinicalPart = () => {
    setClinicalPartActive(!clinicalPartActive)
  }

  const youMustSelectText = translate('coptikk.product.youmustselect');
  const rightEyeText = translate('coptikk.product.righteye');
  const leftEyeText = translate('coptikk.product.lefteye');

  const handleResults = () => {
    setanyProductSelected(true);
  }

  useEffect(() => {
    setanyProductSelected(false);

    if (props.subscriptionToEdit) {
      setanyProductSelected(true);
      setpaymentMethod(props.subscriptionToEdit.paymentMethod);
    }
  }, []);

  useEffect(() => {        
    if (props.subscriptionToEdit.customerSubscriptionItemLeft) {
      if (lensSpecifications.leftEyeStrength !=="" &&  props.subscriptionToEdit.customerSubscriptionItemLeft.strength !== "" && 
      props.subscriptionToEdit.customerSubscriptionItemLeft.strength !== lensSpecifications.leftEyeStrength) {
        setlensSpecificationChangedInEdit(true);
      }
      if (lensSpecifications.leftEyeCurve !== "" && props.subscriptionToEdit.customerSubscriptionItemLeft.curve !== "" && 
      props.subscriptionToEdit.customerSubscriptionItemLeft.curve !== lensSpecifications.leftEyeCurve) {
        setlensSpecificationChangedInEdit(true);
      }
      if (lensSpecifications.leftEyeDiameter !== "" && props.subscriptionToEdit.customerSubscriptionItemLeft.diameter !== "" && 
      props.subscriptionToEdit.customerSubscriptionItemLeft.diameter !== lensSpecifications.leftEyeDiameter) {
        setlensSpecificationChangedInEdit(true);
      }
      if (lensSpecifications.leftEyeCylinder !== "" && props.subscriptionToEdit.customerSubscriptionItemLeft.cylinder !== "" &&
       props.subscriptionToEdit.customerSubscriptionItemLeft.cylinder !== lensSpecifications.leftEyeCylinder) {
        setlensSpecificationChangedInEdit(true);
      }
      if (lensSpecifications.leftEyeAxis !== "" && props.subscriptionToEdit.customerSubscriptionItemLeft.axis !== "" && 
      props.subscriptionToEdit.customerSubscriptionItemLeft.axis !== lensSpecifications.leftEyeAxis) {
        setlensSpecificationChangedInEdit(true);
      }
      if (lensSpecifications.leftEyeAdd !== "" && props.subscriptionToEdit.customerSubscriptionItemLeft.add !== "" && 
      props.subscriptionToEdit.customerSubscriptionItemLeft.add !== lensSpecifications.leftEyeAddOption) {
        setlensSpecificationChangedInEdit(true);
      }
      if (lensSpecifications.leftEyeColor !== "" && props.subscriptionToEdit.customerSubscriptionItemLeft.color !== "" && 
      props.subscriptionToEdit.customerSubscriptionItemLeft.color !== lensSpecifications.leftcolor) {
        setlensSpecificationChangedInEdit(true);
      }
    }
    if (props.subscriptionToEdit.customerSubscriptionItemRight) {
      if (lensSpecifications.rightEyeStrength !== "" && props.subscriptionToEdit.customerSubscriptionItemRight.strength !== "" && 
      props.subscriptionToEdit.customerSubscriptionItemRight.strength !== lensSpecifications.rightEyeStrength) {
        setlensSpecificationChangedInEdit(true);
      }
      if (lensSpecifications.rightEyeCurve !== "" && props.subscriptionToEdit.customerSubscriptionItemRight.curve !== "" && 
      props.subscriptionToEdit.customerSubscriptionItemRight.curve !== lensSpecifications.rightEyeCurve) {
        setlensSpecificationChangedInEdit(true);
      }
      if (lensSpecifications.rightEyeDiameter !== "" && props.subscriptionToEdit.customerSubscriptionItemRight.diameter !== "" && 
      props.subscriptionToEdit.customerSubscriptionItemRight.diameter !== lensSpecifications.rightEyeDiameter) {
        setlensSpecificationChangedInEdit(true);
      }
      if (lensSpecifications.rightEyeCylinder !== "" && props.subscriptionToEdit.customerSubscriptionItemRight.cylinder !== "" && 
      props.subscriptionToEdit.customerSubscriptionItemRight.cylinder !== lensSpecifications.rightEyeCylinder) {
        setlensSpecificationChangedInEdit(true);
      }
      if (lensSpecifications.rightEyeAxis !== "" && props.subscriptionToEdit.customerSubscriptionItemRight.axis !== "" && 
      props.subscriptionToEdit.customerSubscriptionItemRight.axis !== lensSpecifications.rightEyeAxis) {
        setlensSpecificationChangedInEdit(true);
      }
      if (lensSpecifications.rightEyeAdd !== "" && props.subscriptionToEdit.customerSubscriptionItemRight.add !== "" && 
      props.subscriptionToEdit.customerSubscriptionItemRight.add !== lensSpecifications.rightEyeAddOption) {
        setlensSpecificationChangedInEdit(true);
      }
      if (lensSpecifications.rightEyeColor !== "" && props.subscriptionToEdit.customerSubscriptionItemRight.color !== "" && 
      props.subscriptionToEdit.customerSubscriptionItemRight.color !== lensSpecifications.rightcolor) {
        setlensSpecificationChangedInEdit(true);
      }
    }
  }, [lensSpecifications, props && props.subscriptionToEdit]);


  const setPrice = (isRight, price) => {    
    isRight ? setrightEyePrice(price) : setleftEyePrice(price);
  }

  const setNumberOfPackets = (isRight, packets) => {    
    isRight ? setrightEyeNumberOfPackets(packets) : setleftEyeNumberOfPackets(packets);
  }

  const setIsSixMonthsDeliverySubscription = (isRight, isSixMonths) => {    
    isRight ? setrightIsSixMonthsDelivery(isSixMonths) : setleftIsSixMonthsDelivery(isSixMonths);
  }

  useEffect(() => { 
      let clinicalPart = 0; 
      if (clinicalPartActive) {
        clinicalPart = props.subscriptionToEdit ? props.subscriptionToEdit.clinicalPartPrice : props.clinicalPartPrice;
      } 

      if (rightIsSixMonthsDelivery && !leftIsSixMonthsDelivery) {
        settotalPriceOnEdit(((rightEyePrice + (leftEyePrice * 2)) / 6) + clinicalPart);
      }
      else if (!rightIsSixMonthsDelivery && leftIsSixMonthsDelivery) {
        settotalPriceOnEdit((((rightEyePrice * 2) + leftEyePrice) / 6) + clinicalPart);
      }
      else if (rightIsSixMonthsDelivery && leftIsSixMonthsDelivery) {
        settotalPriceOnEdit(((rightEyePrice + leftEyePrice) / 6) + clinicalPart);
      }
      else {
        settotalPriceOnEdit(((rightEyePrice * rightEyeNumberOfPackets + leftEyePrice * leftEyeNumberOfPackets) / 3) + clinicalPart);
      }
  }, [rightEyePrice, leftEyePrice, rightIsSixMonthsDelivery, leftIsSixMonthsDelivery, rightEyeNumberOfPackets, leftEyeNumberOfPackets, clinicalPartActive]);

  const getValuesAndSave = () => {
    const subscription1InfoProduct = subscription1.current.getProductAndVariant();
    const subscription2InfoProduct = subscription2.current && subscription2.current.getProductAndVariant();

    var subscription1Info = subscription1InfoProduct.selectedVariantArticleNumber ? subscription1.current.getLensSpecificationSelectedValues() : null;
    var subscription2Info = !samesubscriptionForLeftEye && subscription2InfoProduct.selectedVariantArticleNumber !== "" ?
      subscription2.current.getLensSpecificationSelectedValues() : null;

    const validateResponse = validateData(subscription1Info, subscription2Info, subscription1InfoProduct, subscription2InfoProduct);

    if (validateResponse.validations1.length <= 0 && validateResponse.validations2.length <= 0 && !paymentMethodError) {
      const subscriptionRightEyeData = subscription1InfoProduct.selectedVariantArticleNumber ?
        getModelDataFormat(subscription1InfoProduct.selectedProduct, subscription1InfoProduct.selectedVariantArticleNumber, subscription1Info, true) : null;
      const subscriptionLeftEyeData = !samesubscriptionForLeftEye && subscription2InfoProduct.selectedVariantArticleNumber ?
        getModelDataFormat(subscription2InfoProduct.selectedProduct, subscription2InfoProduct.selectedVariantArticleNumber, subscription2Info, false) : null;

      post(`/api/customer/savesubscription/${props.customerId}/${samesubscriptionForLeftEye.toString()}/${props.mypages !== null && props.mypages !== undefined}`, {
        customersubscriptionItemRight: subscriptionRightEyeData,
        customersubscriptionItemLeft: samesubscriptionForLeftEye ? subscriptionRightEyeData : subscriptionLeftEyeData,
        paymentMethod: paymentMethod,
        clinicalPartActive: clinicalPartActive,
        clinicalPartPrice: props.clinicalPartPrice,
        storeMarkedNoFreeMonth: storeMarkedNoFreeMonth
      })
        .then(() => {
          props.refresh();
          setpaymentMethodError(false);
        });
    }
  }

  const getModelDataFormat = (baseProductArticleNumber, articleNumber, subscriptionInfo, isRight) => {
    return {
      articleNumber: articleNumber,
      strength: isRight ? subscriptionInfo.rightEyeStrength : subscriptionInfo.leftEyeStrength,
      curve: isRight ? subscriptionInfo.rightEyeCurve : subscriptionInfo.leftEyeCurve,
      diameter: isRight ? subscriptionInfo.rightEyeDiameter : subscriptionInfo.leftEyeDiameter,
      cylinder: isRight ? subscriptionInfo.rightEyeCylinder : subscriptionInfo.leftEyeCylinder,
      axis: isRight ? subscriptionInfo.rightEyeAxis : subscriptionInfo.leftEyeAxis,
      packet: isRight ? subscriptionInfo.rightEyePacket : subscriptionInfo.leftEyePacket,
      add: isRight ? subscriptionInfo.rightEyeAddOption : subscriptionInfo.leftEyeAddOption,
      color: isRight ? subscriptionInfo.rightcolor : subscriptionInfo.leftcolor,
      eyeProductNumber: isRight ? subscriptionInfo.rightEyeProductNumber : subscriptionInfo.leftEyeProductNumber,
      baseProductArticleNumber: baseProductArticleNumber,
    }
  }

  const validateData = (subscription1Info, subscription2Info, subscription1InfoProduct, subscription2InfoProduct) => {
    setvalidationsubscription1([]);
    setvalidationsubscription2([]);
    let validations1 = [];
    let validations2 = [];

    if ((subscription1InfoProduct.selectedProduct === "" || subscription1InfoProduct.selectedVariantArticleNumber === "")
      && (subscription2InfoProduct.selectedProduct === "" || subscription2InfoProduct.selectedVariantArticleNumber === "")) {
      validations1.push(translate('coptikk.adminportal.recommendation.selectproduct'));
    }

    if (subscription1InfoProduct.selectedVariantArticleNumber !== "") {
      validateLensSpecifications(subscription1Info, validations1, true);
    }

    if (!samesubscriptionForLeftEye && subscription2InfoProduct.selectedVariantArticleNumber !== "") {
      validateLensSpecifications(subscription2Info, validations2, false);
    }

    setvalidationsubscription1(validations1);
    setvalidationsubscription2(validations2);

    if (subscription1Info?.lensDurationCategory && (!samesubscriptionForLeftEye ? subscription2Info?.lensDurationCategory : false) &&
      (!samesubscriptionForLeftEye ? subscription1Info?.lensDurationCategory !== subscription2Info?.lensDurationCategory : false)) {
      validations1.push(translate("coptikk.adminportal.subscription.lensdurationforproductsnotallowed"));
    }
    return { validations1, validations2 };
  }

  const validateLensSpecifications = (subscriptionInfo, validations, isRight) => {

    if (!subscriptionInfo) {
      return validations;
    }

    if ((subscriptionInfo.selectedVariantArticleNumber != "" && isRight &&
      (subscriptionInfo.rightEyeStrength === "" || subscriptionInfo.rightEyeStrength === null)) ||
      (subscriptionInfo.selectedVariantArticleNumber != "" && !isRight &&
        (subscriptionInfo.leftEyeStrength === "" || subscriptionInfo.leftEyeStrength === null))) {
      validations.push(translate('coptikk.product.youmustselectfields'));
    }

    if (subscriptionInfo.rightEyeStrength && subscriptionInfo.rightEyeStrength !== '0') {
      if (!subscriptionInfo.rightEyeCurve || subscriptionInfo.rightEyeCurve === '0') {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.curve')} - ${rightEyeText}`);
      }

      if (!subscriptionInfo.rightEyeDiameter || subscriptionInfo.rightEyeDiameter === '0') {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.diameter')} - ${rightEyeText}`);
      }

      if (subscriptionInfo.hasCylinderOption && (!subscriptionInfo.rightEyeCylinder || subscriptionInfo.rightEyeCylinder === '0')) {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.cylinder')} - ${rightEyeText}`);
      }

      if (subscriptionInfo.hasAxisOption && (!subscriptionInfo.rightEyeAxis || subscriptionInfo.rightEyeAxis === '0')) {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.axis')} - ${rightEyeText}`);
      }

      if (subscriptionInfo.hasAddOption && (!subscriptionInfo.rightEyeAddOption || subscriptionInfo.rightEyeAddOption === '0')) {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.addfield')} - ${rightEyeText}`);
      }

      if (subscriptionInfo.hasColorOption && (!subscriptionInfo.rightcolor || subscriptionInfo.rightcolor === '0')) {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.color')} - ${rightEyeText}`);
      }

      if (!subscriptionInfo.rightEyePacket || subscriptionInfo.rightEyePacket === '0') {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.packets')} - ${rightEyeText}`);
      }
    }

    if (subscriptionInfo.leftEyeStrength && subscriptionInfo.leftEyeStrength !== '0') {
      if (!subscriptionInfo.leftEyeCurve || subscriptionInfo.leftEyeCurve === '0') {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.curve')} - ${leftEyeText}`);
      }

      if (!subscriptionInfo.leftEyeDiameter || subscriptionInfo.leftEyeDiameter === '0') {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.diameter')} - ${leftEyeText}`);
      }

      if (subscriptionInfo.hasCylinderOption && (!subscriptionInfo.leftEyeCylinder || subscriptionInfo.leftEyeCylinder === '0')) {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.cylinder')} - ${leftEyeText}`);
      }

      if (subscriptionInfo.hasAxisOption && (!subscriptionInfo.leftEyeAxis || subscriptionInfo.leftEyeAxis === '0')) {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.axis')} - ${leftEyeText}`);
      }

      if (subscriptionInfo.hasAddOption && (!subscriptionInfo.leftEyeAddOption || subscriptionInfo.leftEyeAddOption === '0')) {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.addfield')} - ${leftEyeText}`);
      }

      if (subscriptionInfo.hasColorOption && (!subscriptionInfo.leftcolor || subscriptionInfo.leftcolor === '0')) {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.color')} - ${leftEyeText}`);
      }

      if (!subscriptionInfo.leftEyePacket || subscriptionInfo.leftEyePacket === '0') {
        validations.push(`${youMustSelectText} ${translate('coptikk.product.packets')} - ${leftEyeText}`);
      }
    }

    return validations;
  }

  return (<Fragment>
    <div className='add-recommendation__container subscription'>
      <div className='title-wrapper'>
        <h5 className='title'>{props.subscriptionToEdit.length !== 0 ?
          translate("coptikk.adminportal.subscription.updatesubscription") : translate('coptikk.adminportal.subscription.addsubscription')}</h5>
      </div>
      {error && <div className='error'>{translate('coptikk.adminportal.recommendation.selectproduct')}</div>}
      {paymentMethodError && <div className='error'>{translate('coptikk.adminportal.subscription.selectpaymentmethod')}</div>}
      <div className='error-container'>
          <div>
            {validationsubscription1 && validationsubscription1.map(x => {
                    return <div className='error'>{`${translate('coptikk.product.righteye')} - ${x}`}</div>
            })} 
          </div>
          <div>
            {validationsubscription2 && validationsubscription2.map(x => {
                    return <div className='error'>{`${translate('coptikk.product.lefteye')} -  ${x}`}</div>
            })} 
          </div>
      </div>
      <div className='add-recommendation__wrapper'>
        <Subscriptions onResults={() => handleResults()} ref={subscription1} key={`${refresh}1`}
          hideRightEye={false} hideLeftEye={true} subscriptionToEdit={props.subscriptionToEdit.customerSubscriptionItemRight}
          setPrice={setPrice} setIsSixMonthsDeliverySubscription={setIsSixMonthsDeliverySubscription}
          resetRightEyePrice={() => setrightEyePrice(0)} setNumberOfPackets={setNumberOfPackets}></Subscriptions>
        {!samesubscriptionForLeftEye &&
          <Subscriptions ref={subscription2} onResults={() => handleResults()} key={`${refresh}2`}
            hideRightEye={true} hideLeftEye={false} subscriptionToEdit={props.subscriptionToEdit.customerSubscriptionItemLeft}
            setPrice={setPrice} setIsSixMonthsDeliverySubscription={setIsSixMonthsDeliverySubscription}
            resetLeftEyePrice={() => setleftEyePrice(0)} setNumberOfPackets={setNumberOfPackets}></Subscriptions>}
      </div>
      <div className='copy column'>
        <input type='checkbox'
          onClick={(event) => {
            setsamesubscriptionForLeftEye(!samesubscriptionForLeftEye);
            setleftEyePrice(event.target.checked ? rightEyePrice : 0);
            setleftEyeNumberOfPackets(event.target.checked ? rightEyeNumberOfPackets : 0);
          }}></input>
        {translate('coptikk.adminportal.recommendation.sameinfoforlefteye')}
      </div>
      <div className='clinical column large-6 medium-12 small-12'>
        <div className='clinical__info'>
          <div className='clinical__name'>
            <input 
                id="clinicalcheckbox"
                type="checkbox"
                checked={clinicalPartActive}
                onChange={handleClinicalPart}
            />
            <label>{translate('coptikk.general.clinicalexamination')}</label>
          </div>
          <div className='clinical__price'>{(props.subscriptionToEdit && props.subscriptionToEdit.clinicalPartPrice > 0 ? props.subscriptionToEdit.clinicalPartPrice 
          : props.clinicalPartPrice)} / {translate('coptikk.checkout.cart.month')}</div>
        </div>
        <p className='clinical__description'>{translate('coptikk.general.clinicalexamination.mypage.description')}</p>
      </div>
      {!props.mypages && (props.subscriptionToEdit.length > 0 ? (props.subscriptionToEdit.status === SubscriptionIntiatedStatus ? true : false) : true) && <div className='column'>            
            <input id="freemonthcheckbox" type="checkbox" checked={storeMarkedNoFreeMonth} onChange={(e) => setstoreMarkedNoFreeMonth(e.target.checked)}/>
            <label>{translate('coptikk.adminportal.subscription.disablefreemonth')}</label>            
      </div>}
      {/* Info to be shown only in edit view */}
      {props.subscriptionToEdit && 
        ((props.subscriptionToEdit.customerSubscriptionItemRight !== undefined && props.subscriptionToEdit.customerSubscriptionItemRight !== null) ||
          (props.subscriptionToEdit.customerSubscriptionItemLeft !== undefined && props.subscriptionToEdit.customerSubscriptionItemLeft !== null)) &&
        <div className='subscription__payment-container'>
          {props.subscriptionToEdit.pricePerMonth !== totalPriceOnEdit.toLocaleString('nb-NO', { maximumFractionDigits: 2 }).replace(/\s+/g, '') 
          && totalPriceOnEdit !== 0 && <div>
            <div className='info-row'>
              <p className='updated-price'>{translate("coptikk.subscription.updatedprice.permonth")}</p>
              <p className='updated-price'>
                {totalPriceOnEdit % 1 === 0
                  ? `${totalPriceOnEdit.toLocaleString("nb-NO", { maximumFractionDigits: 0 })},-`
                  : totalPriceOnEdit.toLocaleString("nb-NO", { maximumFractionDigits: 2, minimumFractionDigits: 2 })
                }
              </p>
            </div>
            <div className='info-row'>
              <p className='earlier-price'>{translate("coptikk.subscription.earlierprice.permonth")}</p>
              <p className='earlier-price'>
                {props.subscriptionToEdit.pricePerMonth % 1 === 0
                  ? `${props.subscriptionToEdit.pricePerMonth.toLocaleString("nb-NO", { maximumFractionDigits: 0 })},-`
                  : props.subscriptionToEdit.pricePerMonth.toLocaleString("nb-NO", { maximumFractionDigits: 2, minimumFractionDigits: 2 })
                }
              </p>
            </div>
            {props.subscriptionToEdit.status !== SubscriptionIntiatedStatus && props.subscriptionToEdit.nextStartDateIfEdited !== '' &&
              <div className='info-row tooltip'>
                <p className='active-date'>{translate("coptikk.subscription.entersintoforcetext")}:
                  {props.subscriptionToEdit.nextStartDateIfEdited}
                </p>
                <div>
                  <div className='tooltip' title={translate('coptikk.subscription.tooltip.activedate')}
                    onClick={handleTooltipClick} ref={tooltipRef}>?</div>
                  {/* <p className={`tooltip-description ${isTooltipVisible ? 'show' : ''}`} ref={tooltipDescriptionRef}>
                {translate('coptikk.subscription.tooltip.activedate')} 
              </p>*/}
                </div>
              </div>
            }
          </div>
          }          
        </div>
      }
      <div className='buttons-wrapper'>
        <button className={`save ${anyProductSelected ? 'active' : ''}`}
          onClick={() => { setsamesubscriptionForLeftEye(false); getValuesAndSave() }}>{translate('coptikk.adminportal.savebuttontext')}</button>
        <a className='discard' onClick={() => { setrefresh(refresh ? false : true); setsamesubscriptionForLeftEye(false); props.hideAddSubscription(); }}>{translate('coptikk.adminportal.cancel')}</a>
      </div>
    </div>
  </Fragment>)
}

export default SubscriptionContainer;